// removed by extract-text-webpack-plugin
module.exports = {"logo-centered":"wejMMQHeygFXDQRvC4vgT","logo-left":"psm5rtRibAwjjvQeoYgto"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/style.scss
// module id = 901
// module chunks = 0